/**
 * The faces of a flip card and the keys each one owns on the card: its words live under
 * `face`, the content asset that makes it an image under `slugKey`, and the image URL a
 * served story resolves from that slug under `urlKey`. The validator and the Studio read the
 * faces off this table, but two readers keep their own copy that must change with it: the PHP
 * resolver's `FLIP_CARD_FACES` map in `ResolveStoryAssetData.php`, and the KUI flip card player
 * (`KUIContentStoryAssetActivityFlipCards.vue` and its `flipcards.ts` card type), which reads
 * each face's `urlKey` by name. `test/activities/flipCardFaceCopies.test.ts` fails when they drift.
 */
export const FLIP_CARD_FACE = {
  front: { face: 'front', slugKey: 'frontContentAssetSlug', urlKey: 'frontImageUrl' },
  back: { face: 'back', slugKey: 'backContentAssetSlug', urlKey: 'backImageUrl' },
} as const;

export type FlipCardFaceName = keyof typeof FLIP_CARD_FACE;
export type FlipCardFace = (typeof FLIP_CARD_FACE)[FlipCardFaceName];

export const FLIP_CARD_FACES: readonly FlipCardFace[] = Object.values(FLIP_CARD_FACE);

const SLUG_KEYS: ReadonlySet<string> = new Set(FLIP_CARD_FACES.map(({ slugKey }) => slugKey));

export const isFlipCardSlugKey = (key: string): boolean => SLUG_KEYS.has(key);
